import React from 'react'
import { Link } from 'react-router-dom'

import { withSize } from 'react-sizeme'
import dateformat from 'dateformat'

import withStyles from '@material-ui/core/styles/withStyles'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import ButtonBase from '@material-ui/core/ButtonBase'
import Divider from '@material-ui/core/Divider'
import CardActions from '@material-ui/core/CardActions'
import Button from '@material-ui/core/Button'

import EventIcon from '@material-ui/icons/Event'
import EventNoteIcon from '@material-ui/icons/EventNote'
import EventOverview from './EventOverview'
import { makePath } from '../../../lib';
import { WID } from '../../../constants/Language';
import { Word } from '../../../containers';
import { useEffect } from 'react'
import { useContext } from 'react'
import { SettingsContext } from '../../../Parts/Settings'

dateformat.i18n = {
  dayNames: [
      '日', '月', '火', '水', '木', '金', '土',
      '日曜', '月曜', '火曜', '水曜', '木曜', '金曜', '土曜'
  ],
  monthNames: [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
    'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'
  ],
  timeNames: [
    'a', 'p', 'am', 'pm', 'A', 'P', 'AM', 'PM'
  ]
}

const styles1 = theme => ({
  flexEnd: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  flexBetween: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  thumbnailBox: {
    width: '100%',
  },
  card: {
    width: '100%',
  },
  cardContent: {
    position: 'relative',
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
    overflow: 'hidden',
    height: 140,
  },
  monthlyGrid: {
    marginBottom: theme.spacing.unit * 4,
  },
  whiteGradient: {
    position: 'absolute',
    bottom: 0,
    height: 24,
    width: '100%',
    background: 'linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)',
  },
  contentBox: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  detail: {
    color: theme.palette.grey[700],
    height: '100%',
  },
  monthlyCard: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    marginBottom: theme.spacing.unit * 2,
    backgroundColor: theme.palette.grey[500],
    color: theme.palette.common.white,
    boxShadow: 'none',
  },
  monthlyBox: {
    textAlign: 'center', 
  },
  cardTitle: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    color: theme.palette.grey[700],
  },
  icon: {
    marginRight: theme.spacing.unit,
  },
  emptyThumbnail: {
    display: 'flex',
    width: '100%',
    lignHeight: '2em',
    fontSize: '1.4em',
    paddingTop: 'calc(28% - 0.7em)',
    justifyContent: 'center',
    alignItems: 'center',
    color: theme.palette.grey[400],
  }
})

const RecordsCardContent = withStyles(styles1, { withTheme: true })(withSize()((props) => {
  var styleThumbnail, gridProps, detail, startDateTime, datetime, monthlyRecords, strDate, keys
  const { classes, theme, size, records, grid, disabledMonthlyCard } = props

  const settingsContext = useContext(SettingsContext)
  const { language } = settingsContext

  const handleClick = () => {
    window.scrollTo(0, 0)
  }

  if (records.length === 0) {
    return (
      <div>
        <Typography><Word wid={WID.EVENT_LIST_CARD.DONT_FIND_EVENT_RECORD}/></Typography>
      </div>
    )
  }
  records.sort((a, b) => {
    return (a.startDate + ('startTime' in a ? a.startTime : 0)) - (b.startDate + ('startTime' in b ? b.startTime : 0))
  })
  gridProps = size.width > 800 ? { xs: 4 } : size.width > 600 ? { xs: 6 } : { xs: 12 }
  if (grid) {
    monthlyRecords = {}
    if (disabledMonthlyCard === true) {
      monthlyRecords.records = records
    }
    else {
      records.forEach(rc => {
        startDateTime = rc.startDate + (rc.startTime ? rc.startTime : 0)
        strDate = dateformat(startDateTime, 'yyyymm')
        datetime  = new Date(startDateTime)
        if (monthlyRecords[strDate] === undefined) {
          monthlyRecords[strDate] = [{ month: datetime.getMonth() + 1, year: datetime.getFullYear() }]
        }
        monthlyRecords[strDate].push(rc)
      })
    }
    keys = Object.keys(monthlyRecords)
    keys.sort((a, b) => parseInt(a, 10) > parseInt(b, 10))
    return (
      <div>
        {keys.map(key =>
          <Grid container spacing={16} key={key} className={classes.monthlyGrid}>
          {monthlyRecords[key].map((record, index) => {
            styleThumbnail = {
              backgroundImage: `url(${record.thumbnail})`,
              backgroundColor: theme.palette.grey[200],
              backgroundSize: 'cover',
              backgroundPosition: 'center center',
              width: '100%',
              height: 0,
              paddingBottom: '56%',
            }
            detail = record.detail ?
              record.detail.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'').replace(/&nbsp;/g, '') : undefined
            if ('month' in record) {
              return (
                <Grid item key={index} {...gridProps}>
                  <Card className={classes.monthlyCard}>
                    <div className={classes.monthlyBox}>
                      <Typography color='inherit'>{record.year}</Typography>
                      <Typography variant='display1' color='inherit'>
                        {record.month}
                        <span style={{fontSize: '1rem', marginLeft: theme.spacing.unit / 2}}><Word wid={WID.EVENT_LIST_CARD.MONTH}/></span>
                      </Typography>
                    </div>
                  </Card>
                </Grid>
              )
            }
            return (
              <Grid item key={index} {...gridProps}>
                <Card className={classes.card}>
                  {size.width > 600 ? (
                    <ButtonBase component={Link} to={makePath(`/event/${record.id}`, language)} className={classes.thumbnailBox} onClick={handleClick}>
                      <div style={styleThumbnail}>
                        {!record.thumbnail && (
                          <Typography className={classes.emptyThumbnail}><EventIcon className={classes.icon}/>EVENT</Typography>
                        )}
                      </div>
                    </ButtonBase>
                  ) : record.thumbnail && (
                    <ButtonBase component={Link} to={makePath(`/event/${record.id}`, language)} className={classes.thumbnailBox} onClick={handleClick}>
                      <div style={styleThumbnail}/>
                    </ButtonBase>
                  )}
                  <CardContent className={classes.cardContent}>
                  <EventOverview record={record}/>
                  {detail && (
                    <div style={{height: '100%'}}>
                      <Typography className={classes.detail}>{detail}</Typography>
                    </div>
                  )}
                  <div className={classes.whiteGradient}></div>
                  </CardContent>
                  <CardActions className={classes.flexEnd}>
                    <Button component={Link} to={makePath(`/event/${record.id}`, language)} onClick={handleClick}><Word wid={WID.EVENT_LIST_CARD.SHOW_DETAILS}/></Button>
                  </CardActions>
                </Card>
              </Grid>
            )
          })}
          </Grid>
        )}
      </div>
    )
  }
  else {
    return (
      <Grid container spacing={16}>
        <Grid item xs={12}>
          <Card>
            <CardContent className={classes.cardListContent}>
              <div className={classes.cardTitle}>
                <EventNoteIcon color='inherit' className={classes.icon}/>
                <Typography color='inherit'><Word wid={WID.EVENT_LIST_CARD.CALENDAR}/></Typography>
              </div>
            </CardContent>
            <Divider/>
            {records.map((record, index) => {
              styleThumbnail = {
                backgroundImage: `url(${record.thumbnail})`,
                backgroundColor: theme.palette.grey[100],
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                width: '100%',
                height: 0,
                paddingBottom: '56%',
              }
              return (
                <Grid item key={index}>
                  <ButtonBase component={Link} to={makePath(`/event/${record.id}`, language)} style={{width: '100%', display: 'flex', justifyContent: 'flex-start'}} onClick={handleClick}>
                    <CardContent style={{padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`}}>
                      <EventOverview record={record}/>
                    </CardContent>
                  </ButtonBase>
                  <Divider/>
                </Grid>
              )
            })}
          </Card>
        </Grid>
      </Grid>
    )
  }
}))

const styles = theme => ({
  card: {
    margin: '0 auto'
  },
  cardContent: {
    display: 'flex',
    justifyContent: 'center'
  }
})

function EventListCard(props) {
  const { init, unmount, classes, ready, recordsCardContentSProps, fullWidth, grid, language, auth0 } = props

  useEffect(() => {
    if (auth0) {
      auth0.isAuthenticated()
      .then(result => {
        init()
      })
    }
    return () => {
      unmount()
    }
  }, [auth0])

  var styles = {
    card: {
      maxWidth: fullWidth ? 640 : undefined
    }
  }

  return (
    <div className={classes.card} style={styles.card}>
      {ready && (
        <RecordsCardContent {...recordsCardContentSProps} grid={grid} language={language}/>
      )}
    </div>
  )
}

export default withStyles(styles, { withTheme: true })(EventListCard)


// WEBPACK FOOTER //
// ./src/Pages/Event/components/EventListCard.js